import parentStyles from '../style.postcss';
import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import is from 'is_js';
import { connect, HorizontalSelect, StudentCard, ApiResponseHelper } from 'omni-common-ui';
import RcTooltip from 'rc-tooltip';
import { bindActionCreators } from 'redux';
import { actions as GroupMembers } from 'data/GroupMembers';
import { List, Map } from 'immutable';
import {
  accessors as idpAccessors,
} from 'data/IndividualDevelopmentPlans';
import {
  actions as progressTestsPlanActions,
} from 'data/ProgressTestsPlan';
import {
  actions as progressTestActions,
} from 'data/ProgressTests';
import { actions as UiState } from 'data/UiState';
import { HFV4_SCORE_BANDS } from '../../UnitReportHFv4/StudentReportView/ScoreBand/hfv4ScoreBands';
import { getUnitRange } from '../unitRange';
import {
  getAssessmentPlanFromState,
  getAssessmentProgressTestFromState,
  getStudentAssessmentScores,
} from '../assessmentScores';

const getScoreBandForScore = (score) =>
  HFV4_SCORE_BANDS.find((band) =>
    score >= band.scorePercentageFrom && score <= band.scorePercentageTo
  );

const SCORE_TOOLTIP_WIDTH = 380;

class ScoreTooltip extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { placement: 'bottom' };
    this._onMouseEnter = this._onMouseEnter.bind(this);
    this._onPopupAlign = this._onPopupAlign.bind(this);
  }

  _onMouseEnter() {
    if (!this._el) return;
    const rect = this._el.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const halfWidth = SCORE_TOOLTIP_WIDTH / 2;

    let placement = 'bottom';
    if (centerX - halfWidth < 0) {
      placement = 'bottomLeft';
    } else if (centerX + halfWidth > window.innerWidth) {
      placement = 'bottomRight';
    }

    if (placement !== this.state.placement) {
      this.setState({ placement });
    }
  }

  _onPopupAlign(popupDomNode) {
    const arrowEl = popupDomNode.querySelector('.rc-tooltip-arrow');
    if (!arrowEl || !this._triggerEl) return;
    const popupRect = popupDomNode.getBoundingClientRect();
    const triggerRect = this._triggerEl.getBoundingClientRect();
    const triggerCenterX = triggerRect.left + triggerRect.width / 2;
    let arrowLeft = triggerCenterX - popupRect.left;

    const minArrow = popupRect.width * 0.15;
    const maxArrow = popupRect.width * 0.85;
    if (arrowLeft > maxArrow) {
      const shift = arrowLeft - maxArrow;
      popupDomNode.style.left = `${(parseFloat(popupDomNode.style.left) || 0) + shift}px`;
      arrowLeft = maxArrow;
    } else if (arrowLeft < minArrow) {
      const shift = minArrow - arrowLeft;
      popupDomNode.style.left = `${(parseFloat(popupDomNode.style.left) || 0) - shift}px`;
      arrowLeft = minArrow;
    }
    arrowEl.style.left = `${arrowLeft}px`;
  }

  render() {
    const overlayClassName = this.props.overlayClassName
      ? `${styles.scoreTooltipBase} ${this.props.overlayClassName}`
      : styles.scoreTooltipBase;
    return (
      <div ref={(el) => { this._el = el; }} onMouseEnter={this._onMouseEnter}>
        <RcTooltip
          placement={this.state.placement}
          trigger={['hover']}
          destroyPopupOnHide
          onPopupAlign={this._onPopupAlign}
          overlay={<div>{this.props.overlay}</div>}
          overlayClassName={overlayClassName}
        >
          <div ref={(el) => { this._triggerEl = el; }}>{this.props.children}</div>
        </RcTooltip>
      </div>
    );
  }
}

function formatScoreForTooltip(score) {
  return is.number(score) ? `${score}%` : '-';
}

function buildStudentScoreTooltipOverlay({
  unitRange,
  scorePercentage,
  assessmentScore,
  isReport2,
  hasScore,
  hasAssessment,
}) {
  if (isReport2 && (hasScore || hasAssessment)) {
    return (
      <span>
        Average Score of Unit {unitRange}: <b>{hasScore ? formatScoreForTooltip(scorePercentage) : '-'}</b> | Assessment Score: <b>{hasAssessment ? formatScoreForTooltip(assessmentScore) : '-'}</b>
      </span>
    );
  }
  if (hasScore) {
    return (
      <span>
        Average Score of Unit {unitRange}: <b>{formatScoreForTooltip(scorePercentage)}</b>
      </span>
    );
  }
  return null;
}

class StudentSelect extends PureComponent {

  constructor() {
    super();
    this._getLinkHrefForValue = (studentId) =>
      this.props.buildRoute({ studentId, mode: '' });
  }

  componentWillMount() {
    this._buildStudentSelectOptions(this.props);
    this._fetchAssessmentDataIfNeeded(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.membersInCurrentIdp !== nextProps.membersInCurrentIdp ||
      this.props.studentScores !== nextProps.studentScores ||
      this.props.studentAssessmentScores !== nextProps.studentAssessmentScores ||
      this.props.isReport2 !== nextProps.isReport2 ||
      this.props.reportName !== nextProps.reportName ||
      this.props.courseTypeLevelCode !== nextProps.courseTypeLevelCode) {
      this._buildStudentSelectOptions(nextProps);
    }
    this._fetchAssessmentDataIfNeeded(nextProps);
  }

  _fetchAssessmentDataIfNeeded(props) {
    if (!props.isReport2) return;

    const { groupId } = props;
    props.fetchProgressTestPlanIfNeeded(groupId);

    if (props.assessmentPlan && ApiResponseHelper.shouldFetch(props.assessmentProgressTest)) {
      props.fetchProgressTest(groupId, props.assessmentPlan);
    }
  }

  _renderScoreContent({
    scorePercentage,
    assessmentScore,
    isReport2,
    unitRange,
  }) {
    const hasScore = is.number(scorePercentage);
    const hasAssessment = is.number(assessmentScore);
    const showSplit = isReport2 && (hasScore || hasAssessment);

    if (! hasScore && ! hasAssessment) {
      return null;
    }

    const band = hasScore ? getScoreBandForScore(scorePercentage) : null;
    const scoreStyle = band ? { color: band.color } : {};
    let scoreDisplay = null;

    if (showSplit) {
      const assessmentBand = hasAssessment ? getScoreBandForScore(assessmentScore) : null;
      const assessmentStyle = assessmentBand ? { color: assessmentBand.color } : {};
      scoreDisplay = <div className={styles.StudentSelect_score}>
        <span style={scoreStyle}>{hasScore ? `${scorePercentage}%` : '-'}</span>
        <span className={styles.StudentSelect_scoreDivider}>|</span>
        <span style={assessmentStyle}>{hasAssessment ? `${assessmentScore}%` : '-'}</span>
      </div>;
    } else if (hasScore) {
      scoreDisplay = <div className={styles.StudentSelect_score}
          style={scoreStyle}>{scorePercentage}%</div>;
    }

    const tooltipOverlay = buildStudentScoreTooltipOverlay({
      unitRange,
      scorePercentage,
      assessmentScore,
      isReport2,
      hasScore,
      hasAssessment,
    });

    if (! tooltipOverlay) {
      return scoreDisplay;
    }

    return <ScoreTooltip overlay={tooltipOverlay}
        overlayClassName={showSplit ? styles.StudentSelect_scoreTooltip : undefined}>
      {scoreDisplay}
    </ScoreTooltip>;
  }

  _buildStudentSelectOptions(props) {
    const {
      membersInCurrentIdp,
      studentScores,
      studentAssessmentScores,
      isReport2,
      reportName,
      courseTypeLevelCode,
    } = props;
    const unitRange = getUnitRange(courseTypeLevelCode, reportName);

    if (membersInCurrentIdp.size > 0) {
      this._studentSelectOptions = membersInCurrentIdp.map((option) => {
        const { studentGeneralInfo } = option;
        const scorePercentage = studentScores && studentScores.get(`${studentGeneralInfo.id}`);
        const assessmentScore = isReport2 && studentAssessmentScores
          && studentAssessmentScores.get(`${studentGeneralInfo.id}`);
        const scoreContent = this._renderScoreContent({
          scorePercentage,
          assessmentScore,
          isReport2,
          unitRange,
        });

        const optionHtml = <StudentCard className={styles.StudentCard_hfv4}
            vertical
            borderless
            backgroundless>
          <StudentCard.Profile name={studentGeneralInfo.firstName}
              surname={studentGeneralInfo.lastName}
              localName={studentGeneralInfo.localName}
              avatarUrl={studentGeneralInfo.avatarUrl}
              gender={studentGeneralInfo.gender} />
          {scoreContent}
        </StudentCard>;
        return {
          html: optionHtml,
          value: studentGeneralInfo.id,
          className: styles.StudentSelect_option,
        };
      }).toArray();
    }
  }

  render() {
    const { membersInCurrentIdp, currentMember, shouldHide } = this.props;
    if (currentMember && membersInCurrentIdp.size && membersInCurrentIdp.size > 0) {
      return <div className={parentStyles.IndividualDevelopmentPlan_studentHorizontalSelect}>
        <HorizontalSelect options={this._studentSelectOptions}
            value={currentMember && currentMember.studentGeneralInfo.id}
            isHide={shouldHide}
            getLinkHrefForValue={this._getLinkHrefForValue} />
      </div>;
    }
    return null;
  }

}

function getStudentScores(idpList, idpDetailMap) {
  let studentScores = new Map();
  if (! idpList || idpList.size <= 0) return studentScores;

  idpList.forEach((idp) => {
    const idpDetail = idpDetailMap && idpDetailMap.get(`${idp.id}`);
    const learningResult = idpDetail && idpDetail.get('learningResult');
    const skillResults = learningResult
      ? learningResult.skillResults
      : idp.skillResults;

    const scorePercentage = idpAccessors.calculateHfv4QuizAverageScore(skillResults);
    if (is.number(scorePercentage)) {
      studentScores = studentScores.set(`${idp.studentId}`, scorePercentage);
    }
  });
  return studentScores;
}

function mapStateToProps(state, ownProps) {
  const { groupId, groupIdpId, studentId } = ownProps.params;
  const groupIdpList = idpAccessors.getGroupIdpList(state, groupId);
  const idpList = idpAccessors.getIdpList(groupIdpList, groupIdpId);

  let idpStudentIds = new List();
  if (idpList && idpList.size > 0) {
    idpStudentIds = idpList.map((idp) => idp.studentId);
  }
  const membersInCurrentIdp = GroupMembers.getMembersByGroup(state, groupId)
    .filter(({ studentGeneralInfo: { id } }) =>
    idpStudentIds.indexOf(`${id}`) !== - 1);
  const currentMember = GroupMembers.getMemberById(state, studentId);
  const idpDetailMap = state.get('rootReducer').get('individualDevelopmentPlan');

  const reportName = idpAccessors.getReportName(state, groupIdpId);
  const group = state.get('rootReducer').get('groups').get(groupId);
  const courseTypeLevelCode = group && group.get('courseTypeLevelCode');
  const isReport2 = !!(reportName && /2/.test(reportName));

  let studentAssessmentScores = new Map();
  let assessmentPlan = null;
  let assessmentProgressTest = null;

  if (isReport2) {
    assessmentPlan = getAssessmentPlanFromState(state, groupId);
    assessmentProgressTest = getAssessmentProgressTestFromState(state, assessmentPlan);

    if (ApiResponseHelper.hasSucceeded(assessmentProgressTest)) {
      studentAssessmentScores = getStudentAssessmentScores(
        idpList,
        assessmentProgressTest.data,
      );
    }
  }

  return {
    membersInCurrentIdp,
    currentMember,
    studentScores: getStudentScores(idpList, idpDetailMap),
    studentAssessmentScores,
    isReport2,
    reportName,
    courseTypeLevelCode,
    groupId,
    assessmentPlan,
    assessmentProgressTest,
    shouldHide: ! UiState.getShowNavigationBar(state),
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    {},
    bindActionCreators(progressTestsPlanActions, dispatch),
    bindActionCreators(progressTestActions, dispatch),
  );
}

StudentSelect.propTypes = {
  currentMember: PropTypes.object,
  membersInCurrentIdp: PropTypes.object.isRequired,
  studentScores: PropTypes.object.isRequired,
  studentAssessmentScores: PropTypes.object,
  isReport2: PropTypes.bool,
  reportName: PropTypes.string,
  courseTypeLevelCode: PropTypes.string,
  groupId: PropTypes.string,
  assessmentPlan: PropTypes.object,
  assessmentProgressTest: PropTypes.object,
  fetchProgressTestPlanIfNeeded: PropTypes.func.isRequired,
  fetchProgressTest: PropTypes.func.isRequired,
  buildRoute: PropTypes.func.isRequired,
  shouldHide: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(StudentSelect);



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/StudentSelect/index.jsx